import { FunctionComponent, useContext } from 'react'
import { SimulatorContext } from '@/modules/simulator/contexts/SimulatorContext'
import {
  getSimulationTimestampDataStorage,
  isCompanyME
} from '@/modules/simulator/functions'
import {
  MECompanySuccess,
  CompanySuccess
} from '@/modules/simulator/components/Result'

const ResultPage: FunctionComponent = () => {
  const { simulation } = useContext(SimulatorContext)

  const companyEmployees = simulation.answers.companyEmployees

  const isME =
    (companyEmployees && isCompanyME(companyEmployees)) ||
    getSimulationTimestampDataStorage()

  return isME ? <MECompanySuccess /> : <CompanySuccess />
}

export { ResultPage }
